import React, { useState, useRef, useEffect } from "react";
import Hero from "../Components/Hero";
import Fitur from "../Components/About";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import About from "../Components/Fitur";
import NewsSection from "./news/news";
import DonasiBarangSection from "../Components/About/donasibarang";
import axios from "axios";
import HeroMenu from "../Components/Hero/heromenu";
import MapsPage from "./MapsPages/mapsPages";
import TentangKami from "../Components/tentang/tentang";
import Issue from "../Components/tentang/issue";
import Official from "../Components/tentang/official";
import Pendaftaran from "../Components/form/pendaftaran";
import KonsentrasiPemberdayaan from "../Components/konsentrasi/konsentrasi";
import Lanscape from "../Components/Lanscape/lanscape";

const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("device_id", deviceId);
  }

  return deviceId;
};

const HEADER_HEIGHT = 96;
const LandingPageUdin: React.FC = () => {
  const [currentPage, setCurrentPage] = useState("Beranda");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const berandaRef = useRef<HTMLDivElement>(null);
  const fiturRef = useRef<HTMLDivElement>(null);
  const programPemberdayaanRef = useRef<HTMLDivElement>(null);
  const tentangRef = useRef<HTMLDivElement>(null);
  const isuRef = useRef<HTMLDivElement>(null);
  const galangdanaRef = useRef<HTMLDivElement>(null);
  const regionRef = useRef<HTMLDivElement>(null);
  const jenisGeraiRef = useRef<HTMLDivElement>(null);
  const programRef = useRef<HTMLDivElement>(null);
  const pendaftaranRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const recordVisitor = async () => {
      try {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/visitor/record`, {
          website_code: "yatim",
          device_id: getDeviceId(),
        });
      } catch (error) {
        console.error("Gagal record visitor", error);
      }
    };

    recordVisitor();
  }, []);

  const handleMenuClick = (page: string) => {
    if (page === "Merchant Bisnis") {
      setCurrentPage(page);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    setCurrentPage(page);

    setTimeout(() => {
      const targetRef = {
        Beranda: berandaRef,
        "Tentang Kami": tentangRef,
        // Isu: isuRef,
        Program: programPemberdayaanRef,
        Pendaftaran: pendaftaranRef,
        // "Donasi Barang": programRef,
        "Donasi Kita": fiturRef,
        "Galang Dana": galangdanaRef,
        "Region Check": regionRef,
        Berita: jenisGeraiRef,
      }[page];

      if (targetRef?.current) {
        window.scrollTo({
          top: targetRef.current.offsetTop - HEADER_HEIGHT,
          behavior: "smooth",
        });
      }
    }, 100); // Memberi waktu agar komponen bisa update sebelum scroll

    setIsMenuOpen(false);
  };

  return (
    <section className="font-montserrat  mx-auto bg-gray-100">
      <div className="fixed top-0 left-0 w-full z-40 bg-white">
        <Navbar currentPage={currentPage} isMenuOpen={isMenuOpen} handleMenuClick={handleMenuClick} setIsMenuOpen={setIsMenuOpen} />
      </div>

      <section className="pt-[80px] grid grid-cols-1">
        <>
          <div ref={berandaRef}>
            <Hero />
          </div>

          <div>
            <HeroMenu />
          </div>

          <div>
            <Lanscape />
          </div>

          <div ref={tentangRef}>
            <TentangKami />
          </div>
          <div>
            <Issue />
          </div>

          <div>
            <Official />
          </div>
          <div ref={programPemberdayaanRef}>
            <KonsentrasiPemberdayaan />
          </div>

          <div ref={pendaftaranRef}>
            <Pendaftaran />
          </div>
          {/* 
          <div ref={programRef} className="mt-6 md:mt-8 lg:mt-10">
            <DonasiBarangSection />
          </div> */}

          <div ref={fiturRef}>
            <Fitur />
          </div>

          {/* <div ref={jenisGeraiRef}>
            <JenisGerai />
          </div> */}

          <div ref={galangdanaRef}>
            <About />
          </div>

          <div ref={regionRef}>
            <MapsPage />
          </div>

          <div ref={jenisGeraiRef}>
            <NewsSection />
          </div>

          <Footer />
        </>
      </section>
    </section>
  );
};

export default LandingPageUdin;
